import React, { useEffect, useState } from 'react';
import { Styles } from '../styles/courseCategory.js';
import Services from '../../../services/service';
import { useDispatch } from 'react-redux';
import { categoryData } from '../../../redux-files/Actions/courseTypeAction';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import learnerService from '../../../services/learnerService';
import UserService from '../../../services/UserService.js';

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    //{
    //     code: 'hi',
    //     name: 'Hindi',
    //     country_code: 'in'
    // },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    // {
    //     code: 'pu',
    //     name: 'Punjabi',
    //     country_code: 'in'
    // },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
]

const CourseCategory = () => {

    useEffect(() => {
        UserService.generateToken();
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])
    let [category, setCategory] = useState([{ categoryName: '', categoryLength: 0 }]);
    const [color,setColor] = useState(false)
    //let [checkState,setCheckState] = useState(false);
    let cat = [];
    let json = {};
    let counter = 0;
    const dispatch = useDispatch();
    useEffect(() => {
        learnerService.getPublishCourses()
            .then(res => {
                res.data.map((data, i) => {

                    if (json[data.categoryName] == undefined) {
                        json[data.categoryName] = 1;
                    }
                    else {
                        counter = json[data.categoryName];
                        counter++;
                        json[data.categoryName] = counter;
                    }
                })

                for (var key in json) {
                    cat.push({ categoryName: key, categoryLength: json[key] });
                }
                setCategory(cat);
            })

            .catch(err => {

            })


    }, [])


    const categoryHandler = (value) => {
        dispatch(categoryData(value));
       
    }

    return (
        <Styles>
            {/* Course Tag */}
            <div className="course-category">
                <h5>{t('course_category')}</h5>
                <ul className="category-item list-unstyled ">
                    {category?.map((data, i) => {
                        return (
                            <li className={`check-btn shadow-sm rounded`}>
                                <label htmlFor="cat1" style={{ marginLeft: "10px", marginTop: "5px" }} className='catLabel  '><input type="radio" name="category" className="form-check-input" value={data.categoryName} onClick={(e) => categoryHandler(data.categoryName)} />
                                    {data.categoryName}
                                    <span>
                                        ({data.categoryLength})
                                    </span>
                                </label>
                                {/* <label htmlFor="cat1" style={{ marginLeft: "10px", marginTop: "5px" }}><p name="category" className="form-check-input" value={data.categoryName} onClick={(e) => categoryHandler(data.categoryName)} >{data.categoryName}<span>({data.categoryLength})</span></p></label> */}
                            </li>

                        )
                    })
                    }
                </ul>
            </div>
        </Styles>
    )
}

export default CourseCategory